// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nwsvO","col":"styles_col__1QzyN","actions":"styles_actions__2m6Zx","conflict":"styles_conflict__1-X2X"};